<template>
  <button type="button" :class="['zm-icons-button', 'zm-icons-button--' + size]" @click="onClick">
    <svg
      aria-hidden="true"
      class="zm-icons"
    >
      <use :href="name" :xlink:href="name" />
      <slot />
    </svg>
  </button>
</template>

<script>
  export default {
    name: 'ButtonIcon',
    props: {
      size: {
        required: true,
        type: String
      },
      name: {
        required: true,
        type: String
      },
      ariaLabel: {
        required: true,
        type: String
      }
    },
    methods: {
      onClick() {
        this.$emit('click');
      }
    }
  };
</script>
